module.exports = __webpack_public_path__ + "img/oeillet1_md.4a77ccc2.jpg";